import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router/index.js'
import { initKeycloak } from './services/keycloak.js'
import './assets/css/global.css'
import '@/assets/css/app-shell.css'

async function bootstrap() {
  const app = createApp(App)
  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)
  app.use(pinia)
  app.use(router)

  // Keycloak init — silently checks if user has active session.
  // On dev, if Keycloak is unreachable, we fall back to mock auth.
  try {
    await initKeycloak()
  } catch (e) {
    console.warn('[Custus] Keycloak unavailable, running in mock-auth mode:', e.message)
  }

  app.mount('#app')
}

bootstrap()
